
export const english = {
    requiredError:'This field is required',
    init:'Home',
    cancelDocumentText:'Cancelar documento'
};
